var React = require('react');

function ArrowCircle (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M0.999997 40C0.999995 18.4609 18.4609 1.00001 40 1C61.5391 1 79 18.4609 79 40C79 61.5391 61.5391 79 40 79C18.4609 79 0.999998 61.5391 0.999997 40ZM40 3.49691e-06C62.0914 1.56562e-06 80 17.9086 80 40C80 62.0914 62.0914 80 40 80C17.9086 80 -1.56562e-06 62.0914 -3.49691e-06 40C-5.4282e-06 17.9086 17.9086 5.4282e-06 40 3.49691e-06ZM40.8047 47L38.8047 47L38.8047 40.5L34.6085 40.5L39.8047 33L45.0008 40.5L40.8047 40.5L40.8047 47Z","fill":"currentColor"}));
}

ArrowCircle.defaultProps = {"width":"80","height":"80","viewBox":"0 0 80 80"};

module.exports = ArrowCircle;

ArrowCircle.default = ArrowCircle;
